export default __webpack_public_path__ + "static/pragicts-ai-legal-d67b3670589cdad94eee985caf4e577a.jpg";